import type { WallOfLove } from "../types";
import WallOfLoveListItem from "./wall-of-love-list-item";
import type { UserRole } from "@/modules/membership";

export interface WallOfLoveListProps {
	wallOfLoves: WallOfLove[];
	onDelete?: (id: string) => void;
	onEdit?: (id: string) => void;
	onStatusChange?: (id: string, status: string) => void;
	brandUrl?: string;
	userRole?: UserRole | null;
}

export default function WallOfLoveList({ wallOfLoves, onDelete, onEdit, onStatusChange, brandUrl, userRole }: WallOfLoveListProps) {
	return (
		<div className="space-y-2">
			{wallOfLoves.map((wallOfLove) => (
				<WallOfLoveListItem
					key={wallOfLove.id}
					wallOfLove={wallOfLove}
					onDelete={onDelete}
					onEdit={onEdit}
					onStatusChange={onStatusChange}
					brandUrl={brandUrl}
					userRole={userRole}
				/>
			))}
		</div>
	);
}
